import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { DoOrDumpReportDashboard, type DoOrDumpDashboardPreviewReason } from "@/components/dashboard/DoOrDumpReportDashboard";
import { loadDashboardDoOrDumpReport } from "@/lib/dashboard-report";
import type { DoOrDumpDashboardPayload } from "@/types/do-or-dump-dashboard";

export function DashboardClient() {
  const [searchParams] = useSearchParams();
  const [report, setReport] = useState<DoOrDumpDashboardPayload | null>(null);
  const [preview, setPreview] = useState(false);
  const [previewReason, setPreviewReason] = useState<DoOrDumpDashboardPreviewReason | undefined>();
  const [showPaidBanner, setShowPaidBanner] = useState(false);

  useEffect(() => {
    if (searchParams.get("dod_checkout") === "success") {
      setShowPaidBanner(true);
    }
  }, [searchParams]);

  useEffect(() => {
    void loadDashboardDoOrDumpReport()
      .then((j) => {
        setReport(j.report);
        setPreview(Boolean(j.preview));
        setPreviewReason(j.previewReason);
      })
      .catch(() => setReport(null));
  }, []);

  if (!report) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-2 px-4 text-center text-zinc-600">
        <p className="text-sm font-medium">Loading your report…</p>
        <p className="max-w-md text-xs text-zinc-500">Hang tight — we&apos;re opening your saved Do or Dump results.</p>
      </div>
    );
  }

  return (
    <>
      {showPaidBanner ? (
        <div className="mx-auto max-w-6xl px-4 pt-6 sm:px-6 lg:px-8">
          <div className="flex items-start justify-between gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-950">
            <p className="font-medium">Payment received — we&apos;ll follow up on your selected add‑ons at the email used at checkout.</p>
            <button
              type="button"
              onClick={() => setShowPaidBanner(false)}
              className="shrink-0 rounded-lg px-2 py-1 text-xs font-semibold text-emerald-800 hover:bg-emerald-100"
            >
              Dismiss
            </button>
          </div>
        </div>
      ) : null}
      <DoOrDumpReportDashboard payload={report} preview={preview} previewReason={previewReason} />
    </>
  );
}
